import { ChangeDetectionStrategy, Component } from "@angular/core";

import { I18nPipe } from "@bitwarden/ui-common";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "vault-manually-open-extension",
  templateUrl: "./manually-open-extension.component.html",
  imports: [I18nPipe],
})
export class ManuallyOpenExtensionComponent {}
